import { BrowserRouter as Router } from "react-router-dom";
import API from "./components/API";
import Content from "./components/Content/Content";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import Support from "./components/Support";
import DevApi from "./components/DevApi";
import Footer from "./components/Footer";

function App() {
  return (
    <Router>
      <Navbar />
      <Hero />
      <Support />
      <Content />
      <API />
      <DevApi />
      <Footer />
    </Router>
  );
}

export default App;
